import dayjs from "dayjs";
import updateLocale from "dayjs/plugin/updateLocale";
import { useEffect, type FC, type PropsWithChildren } from "react";
import { installationSetup } from "@/shared/utils/installation-setup";
import { ThemeInitializer } from "./ThemeInitializer";
import { AuthInitializer } from "./AuthInitializer";
import { ImportVcfInitializer } from "./ImportVcfInitializer";

export const AppInitializer: FC<PropsWithChildren> = ({ children }) => {
  dayjs.extend(updateLocale);

  useEffect(() => {
    installationSetup();
  }, []);

  return (
    <>
      <AuthInitializer>
        <ThemeInitializer>
          <ImportVcfInitializer>{children}</ImportVcfInitializer>
        </ThemeInitializer>
      </AuthInitializer>
    </>
  );
};
